import { Link } from "react-router-dom";
import * as ROUTES from "../../../constants/routes";
import { NavFooterItem, UserInfoContainer } from "../style";
import { Cog } from "@styled-icons/boxicons-solid/Cog";

const UserAvatarLink = ({ authUser }) => {
  return (
    <NavFooterItem>
      <Link to={ROUTES.USER_PROFILE}>
        <UserInfoContainer>
          <h1>{authUser?.displayName?.charAt(0).toUpperCase() || "U"}</h1>
          <Cog />
        </UserInfoContainer>
        <p>Profile</p>
      </Link>
    </NavFooterItem>
  );
};

export default UserAvatarLink;
